module.exports = __webpack_public_path__ + "img/PKW.62160b15.svg";